export const jsonMenu = [
  {
    icon: "pie-chart",
    name: "Gerencial",
    match: "#",
    rule: "RULE_OFFICER_GERENCIAL",
    items: [
      {
        icon: "profile",
        name: "Precatórios",
        match: "/gerencial/precatorios",
        items: [],
        rule: "RULE_OFFICER_GERENCIAL_PRECATORIOS"
      },
      {
        icon: "dollar",
        name: "Cotações",
        match: "/gerencial/cotacoes",
        items: [],
        rule: "RULE_OFFICER_GERENCIAL_QUOTES"
      },
      {
        icon: "file-search",
        name: "Operações",
        match: "/gerencial/operacoes",
        items: [],
        rule: "RULE_OFFICER_GERENCIAL_OPERATIONS"
      }
    ]
  },
  {
    icon: "file",
    name: "Solicitação de pagamento",
    match: "#",
    rule: "RULE_OFFICER_NF_PAYMENT",
    items: [
      {
        icon: "folder-add",
        name: "Solicitar",
        match: "/nf-payment/request",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_REQUEST"
      },
      {
        icon: "ordered-list",
        name: "Solicitado",
        match: "/nf-payment/demmanded",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_DEMMANDED"
      },
      {
        icon: "calendar",
        name: "Agendado",
        match: "/nf-payment/scheduled",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_SCHEDULED"
      },
      {
        icon: "dollar",
        name: "Pago",
        match: "/nf-payment/paid",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_PAID"
      },
      {
        icon: "issues-close",
        name: "Em revisão",
        match: "/nf-payment/in-review",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_IN_REVIEW"
      },
      {
        icon: "stop",
        name: "Rejeitado",
        match: "/nf-payment/rejected",
        items: [],
        rule: "RULE_OFFICER_VIEW_NF_PAYMENT_REJECTED"
      }
    ]
  },
  {
    icon: "dashboard",
    name: "Monitor",
    match: "#",
    rule: "RULE_OFFICER_MONITOR",
    items: [
      {
        icon: "ordered-list",
        name: "Meus Precatórios",
        match: "/monitor/precatorios/list",
        items: [],
        rule: "RULE_OFFICER_MONITOR_PRECATORIOS_LIST"
      },
      {
        icon: "dollar",
        name: "Cotações",
        match: "#",
        items: [
          {
            icon: "dollar",
            name: "Minhas Cotações",
            match: "/monitor/cotacoes/user",
            items: [],
            rule: "RULE_OFFICER_MONITOR_QUOTES"
          },
          {
            icon: "dollar",
            name: "Todas Cotações",
            match: "/monitor/cotacoes/all",
            items: [],
            rule: "RULE_OFFICER_USER_CAN_VIEW_ALL_QUOTES"
          },
          
          {
            icon: "dollar",
            name: "Todas Cotações de Pré-Percatorio",
            match: "/monitor/pre-precatorio/all",
            items: [],
            rule: "RULE_OFFICER_USER_CAN_VIEW_ALL_PRE_PRECATORIO"
          }
        ],
        rule: "RULE_OFFICER_MONITOR_QUOTES"
      },
      {
        icon: "file-search",
        name: "Minhas Operações",
        match: "/monitor/operacoes",
        items: [],
        rule: "RULE_OFFICER_MONITOR_OPERATIONS"
      },
      {
        icon: "file-search",
        name: "Operações com pendências",
        match: "/monitor/operacoes-com-pendencias",
        items: [],
        rule: "RULE_OFFICER_MONITOR_PENDENCY_OPERATIONS"
      },
      {
        icon: "container",
        name: "Pendência enviadas",
        match: "/monitor/pending-sent",
        items: [],
        rule: "RULE_OFFICER_PENDING_SENT"
      },
      {
        icon: "container",
        name: "Operações Arquivadas",
        match: "/monitor/archived",
        items: [],
        rule: "RULE_OFFICER_MONITOR_ARCHIVED"
      },
      {
        icon: "container",
        name: "Operações Rejeitadas",
        match: "/monitor/rejected",
        items: [],
        rule: "RULE_OFFICER_MONITOR_REJECTED"
      },
      {
        icon: "cloud-upload",
        name: "Upload de Documentos",
        match: "/monitor/upload",
        items: [],
        rule: "RULE_OFFICER_MONITOR_UPLOAD"
      },
      {
        icon: "double-right",
        name: "Projetos Especiais",
        match: "/monitor/trade-special-project",
        items: [],
        rule: "RULE_OFFICER_VIEW_TRADE_SPECIAL_PROJECT"
      },
      {
        icon: "dollar",
        name: "Operações Finalizadas",
        match: "/monitor/trade-post-purchase",
        items: [],
        rule: "RULE_OFFICER_VIEW_TRADE_POST_PURCHASE"
      }
    ]
  },
  {
    icon: "tool",
    name: "Ferramentas",
    match: "#",
    rule: "RULE_OFFICER_TOOLS",
    level: 0,
    items: [
      {
        icon: "calculator",
        name: "Calculadora Manual",
        match: "/ferramentas/calculadora/manual",
        items: [],
        rule: "RULE_OFFICER_TOOLS_CALCULATOR_MANUAL",
        level: 1
      },
      {
        icon: "search",
        name: "Calculadora Automática",
        match: "/monitor/precatorios/consult",
        items: [],
        rule: "RULE_OFFICER_MONITOR_PRECATORIOS_CONSULT"
      }
    ]
  },
  {
    icon: "user",
    name: "Administração",
    match: "#",
    rule: "RULE_OFFICER_ADMIN",
    items: [
      {
        icon: "team",
        name: "Usuários",
        match: "/usuarios",
        items: [],
        rule: "RULE_OFFICER_ADMIN_USERS"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/common/side-menu/side-menu-json.ts